const HtmlWrapper = ({children}) => (
    <html xmlns="http://www.w3.org/1999/xhtml">
        {children}
    </html>
)

export default HtmlWrapper